import {createContext} from "react";
import {IData} from "common/interface/interface";
const DataObject: IData = {};

export const dataContext = createContext({
  data: DataObject,
  setData: (data: IData) => {},
});
